module.exports = __webpack_public_path__ + "static/media/personal.f0717043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal.jpg
// module id = 352
// module chunks = 0